export default {
    conditionImport: 'เงื่อนไขการนำเข้า',
    firstImportCondition: 'สร้างข้อมูลพนักงานก่อนการอัพโหลดรูปภาพใบหน้า',
    secondImportCondition: 'ไฟล์ต้องเป็นประเภท Zip ไฟล์ รูปภาพประเภท .jpg และชื่อรูปภาพตั้งจากรหัสพนักงาน เช่น 12345',
    thirdImportCondition: 'กรุณาตรวจสอบข้อมูลใน Zip ไฟล์ให้ถูกต้องก่อนที่จะอัพโหลด',
    shouldBeZip: 'ไฟล์ .Zip',
    importResult: 'จำนวนทั้งหมด'
}
